import { Sparkles, ImageIcon } from 'lucide-react';
import { toast } from 'sonner';

import { LabeledSelect } from '@/components/ui/labeled-select';
import { ConstructedPrompt } from '@/components/ui/constructed-prompt';
import { RenderArea } from '@/components/ui/render-area';
import { ActionButton } from '@/components/ui/action-button';

import { ASPECT_RATIOS, RESOLUTIONS } from '@/@types/photostudio';
import type { IPhotostudioPreviewColumnProps } from '@/@types/photostudio';

const handleGenerateScene = () => {
  toast.info('Generate Scene feature coming soon');
};

export function PhotostudioPreviewColumn(props: IPhotostudioPreviewColumnProps) {
  const {
    constructedPrompt,
    resolution,
    setResolution,
    aspectRatio,
    setAspectRatio,
    isReadyToGenerate,
    isGenerating,
    generatedImageUrl,
    error,
    onGenerate,
    onDownload,
    onOpenSaveDialog,
  } = props;

  return (
    <div className="flex-1 sticky top-6 self-start space-y-6">
      <ConstructedPrompt
        prompt={constructedPrompt || 'Fill in the form to construct your prompt...'}
      />

      <div className="flex items-end gap-3">
        <div className="w-20">
          <LabeledSelect
            label="Resolution"
            value={resolution}
            onChange={setResolution}
            options={RESOLUTIONS}
            placeholder="1K"
          />
        </div>
        <div className="w-[100px]">
          <LabeledSelect
            label="Aspect Ratio"
            value={aspectRatio}
            onChange={setAspectRatio}
            options={ASPECT_RATIOS}
            placeholder="16:9"
          />
        </div>
        <div className="flex-1">
          <ActionButton
            variant="primary"
            icon={Sparkles}
            onClick={onGenerate}
            loading={isGenerating}
            disabled={!isReadyToGenerate}
          >
            Generate Image
          </ActionButton>
        </div>
      </div>

      <ActionButton
        variant="secondary"
        icon={ImageIcon}
        onClick={handleGenerateScene}
        disabled
        title="Coming Soon"
      >
        Generate Scene (Coming Soon)
      </ActionButton>

      <RenderArea
        imageUrl={generatedImageUrl}
        isLoading={isGenerating}
        label="Generated Image"
        onDownload={generatedImageUrl ? onDownload : undefined}
        onSave={generatedImageUrl ? onOpenSaveDialog : undefined}
      />

      {error && (
        <div className="rounded-md bg-destructive/10 p-3 text-sm text-destructive">{error}</div>
      )}
    </div>
  );
}
